import { Quote, Star } from "lucide-react";

const ITEMS = [
    {
        sector: "PCP Motor Finance",
        initials: "AM",
        amount: "£4,820",
        quote: "I assumed my old PCP deal was just normal — turns out I was mis-sold the whole thing. ClaimHub did everything. Money landed in 9 weeks.",
        name: "Anonymised client",
        location: "Manchester",
    },
    {
        sector: "Housing Disrepair",
        initials: "PL",
        amount: "£8,150",
        quote: "Council ignored my mould complaints for three winters. ClaimHub got the repairs done AND my compensation. My family is finally safe.",
        name: "Anonymised client",
        location: "Birmingham",
    },
    {
        sector: "Personal Injury",
        initials: "SR",
        amount: "£12,400",
        quote: "Hit by a van on the cycle path. From my hospital bed I filled in a 2-minute form. Honestly that's all I had to do. Brilliant team.",
        name: "Anonymised client",
        location: "Leeds",
    },
    {
        sector: "Medical Negligence",
        initials: "DK",
        amount: "£34,000",
        quote: "Delayed cancer diagnosis cost us a year of treatment options. ClaimHub matched us with a specialist firm and held the trust accountable.",
        name: "Anonymised client",
        location: "Glasgow",
    },
    {
        sector: "Data Breach",
        initials: "FJ",
        amount: "£1,250",
        quote: "Three small claims combined into one — I had no idea data breach claims even existed. Smooth, GDPR-compliant, no fuss.",
        name: "Anonymised client",
        location: "Bristol",
    },
    {
        sector: "Flight Delay",
        initials: "TH",
        amount: "€2,400",
        quote: "Family of four delayed 7 hours from Tenerife. Airline refused. ClaimHub paid us within six weeks. Booked the next holiday with it.",
        name: "Anonymised client",
        location: "Liverpool",
    },
];

const PALETTE = [
    "from-emerald-500/20 to-emerald-600/10 text-emerald-700 bg-emerald-50",
    "from-blue-500/20 to-blue-600/10 text-blue-700 bg-blue-50",
    "from-amber-500/20 to-amber-600/10 text-amber-700 bg-amber-50",
    "from-fuchsia-500/20 to-fuchsia-600/10 text-fuchsia-700 bg-fuchsia-50",
    "from-cyan-500/20 to-cyan-600/10 text-cyan-700 bg-cyan-50",
    "from-rose-500/20 to-rose-600/10 text-rose-700 bg-rose-50",
];

export default function Testimonials() {
    return (
        <section className="section-pad bg-white">
            <div className="container-x">
                <div className="max-w-2xl">
                    <span className="text-eyebrow">Real outcomes</span>
                    <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight text-navy-900">
                        Anonymised wins from real ClaimHub clients.
                    </h2>
                    <p className="mt-5 text-base text-slate-600 leading-relaxed">
                        We protect every client&apos;s privacy by default — names are anonymised, but the cases and amounts recovered are real.
                    </p>
                </div>

                <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {ITEMS.map((t, i) => (
                        <div key={t.quote} className="card-soft p-7 flex flex-col">
                            <div className="flex items-center justify-between mb-5">
                                <div className={`relative w-12 h-12 rounded-full flex items-center justify-center font-display font-bold text-base bg-gradient-to-br ${PALETTE[i % PALETTE.length].split(" ").slice(0, 2).join(" ")} ${PALETTE[i % PALETTE.length].split(" ").slice(2).join(" ")}`}>
                                    {t.initials}
                                </div>
                                <div className="flex items-center gap-0.5">
                                    {Array.from({ length: 5 }).map((_, k) => (
                                        <Star key={k} className="w-4 h-4 fill-amber-400 text-amber-400" />
                                    ))}
                                </div>
                            </div>
                            <div className="text-[11px] uppercase tracking-wider text-emerald-600 font-bold">{t.sector}</div>
                            <div className="mt-1 font-display text-3xl font-bold text-navy-900">{t.amount}</div>
                            <Quote className="w-5 h-5 mt-4 text-slate-300" />
                            <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{t.quote}</p>
                            <div className="mt-5 pt-4 border-t border-slate-100 text-xs text-slate-500">
                                {t.name} · {t.location}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
